export default {
  changeFeedbackButtonAriaLabel: 'Change feedback button',
  changeFeedbackButton: 'Change Feedback',
  viewFeedback: 'View Feedback',
};
